const BASE='https://keycloak.okton.com.br/platform-api/v1/admin/ai-learning';

export type LearningCandidate={
  id:string;
  interactionId:string|null;
  scopeType:'global'|'company'|'branch';
  companyId:string|null;
  branchId:string|null;
  systemId:string;
  candidateType:'answer'|'intent'|'procedure'|'fact';
  piiStatus:'pending'|'clean'|'redacted'|'blocked';
  reviewStatus:'pending'|'approved'|'rejected'|'merged';
  confidence:number;
  sanitizedQuestion:string|null;
  sanitizedAnswer:string|null;
  provenance:Record<string,unknown>;
  createdAt:string;
  reviewedAt:string|null;
  reviewedBy:string|null;
};

export type LearningAnswer={
  id:string;
  scopeType:'global'|'company'|'branch';
  companyId:string|null;
  branchId:string|null;
  systemId:string;
  module:string;
  topic:string;
  question:string;
  answer:string;
  status:'draft'|'approved'|'retired';
  confidence:number;
  usageCount:number;
  approvedBy:string|null;
  approvedAt:string|null;
  sourceVersion:string;
  knowledgeVersion:string;
  createdAt:string;
  updatedAt:string;
  validFrom:string;
  validUntil:string|null;
};

async function request(token:string,path:string,signal?:AbortSignal,init?:RequestInit):Promise<any>{
  const response=await fetch(BASE+path,{
    ...init,
    signal,
    credentials:'include',
    headers:{
      Authorization:'Bearer '+token,
      'Content-Type':'application/json',
      ...(init?.headers||{})
    }
  });
  if(!response.ok){
    let message='Não foi possível processar o aprendizado.';
    try{
      const body=await response.json();
      if(typeof body?.message==='string')message=body.message;
    }catch{}
    throw new Error(message);
  }
  const body=await response.json();
  return body.data;
}

export function loadLearningCandidates(token:string,signal:AbortSignal):Promise<LearningCandidate[]>{
  return request(token,'/candidates',signal);
}

export function loadLearningAnswers(token:string,signal:AbortSignal):Promise<LearningAnswer[]>{
  return request(token,'/answers',signal);
}

export function reviewLearningCandidate(token:string,id:string,decision:'approved'|'rejected'):Promise<LearningCandidate>{
  return request(token,'/candidates/'+encodeURIComponent(id)+'/review',undefined,{
    method:'POST',
    body:JSON.stringify({decision})
  });
}

function newUuid():string{
  const bytes=new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6]=(bytes[6]&0x0f)|0x40;
  bytes[8]=(bytes[8]&0x3f)|0x80;
  const h=Array.from(bytes,b=>b.toString(16).padStart(2,'0')).join('');
  return h.slice(0,8)+'-'+h.slice(8,12)+'-'+h.slice(12,16)+'-'+h.slice(16,20)+'-'+h.slice(20);
}

export function promoteLearningCandidate(token:string,id:string):Promise<LearningAnswer>{
  return request(token,'/candidates/'+encodeURIComponent(id)+'/promote',undefined,{
    method:'POST',
    body:JSON.stringify({answerId:newUuid()})
  });
}

export function retireLearningAnswer(token:string,id:string):Promise<LearningAnswer>{
  return request(token,'/answers/'+encodeURIComponent(id)+'/retire',undefined,{
    method:'POST',
    body:'{}'
  });
}
